import React, { useEffect, useState, Fragment } from 'react';
import Masonry from 'react-masonry-component';

import sanityClient from '../../sanity-client.js';
import imageUrlBuilder from '@sanity/image-url';
import { isMobile } from 'react-device-detect';

import './styles.scss';

const builder = imageUrlBuilder(sanityClient);

function urlFor(source) {
  if (isMobile) {
    return builder.image(source).width(640).format('webp');
  }
  return builder.image(source).format('webp');
}

const MasonryGrid = (props) => {
  const masonryData = props.show;

  const [imageModal, setImageModal] = useState({
    showModal: false,
    disablePage: false,
    modalSrc: null,
    imageIndex: null,
    currentSectionLength: null
  });

  // Disable Page scroll on Modal open
  useEffect(() => {
    if (imageModal.disablePage === true) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  }, [imageModal]);

  const masonryOptions = {
    columnWidth: 0,
    // fitWidth: true,
    transitionDuration: 0,
    resize: true,
    // gutter: 14,
    gutter: 0,
    itemSelector: '.masonry__tile'
  };

  const childElements =
    masonryData &&
    masonryData.map((element, index) => {
      return (
        <li key={index} className="masonry__tile ">
          <div className="tile__container">
            <div
              className="image__wrap lqip"
              style={{
                backgroundImage: `url(${element.asset.metadata.lqip})`,
                paddingTop: `calc(100% / ${element.asset.metadata.dimensions.aspectRatio})`
              }}
            >
              <img src={urlFor(element.asset).url()} alt={element.alt} />
            </div>
            <div
              className="masonry__info"
              onClick={() => {
                setImageModal({
                  showModal: true,
                  disablePage: true,
                  modalSrc: urlFor(element.asset).url(),
                  imageIndex: index,
                  currentSectionLength: masonryData.length
                });
              }}
            >
              <span>{element.title}</span>
            </div>
          </div>
        </li>
      );
    });

  // prettier-ignore
  // Modal Slider Func to change slides
  const onSet = (type) => {
    if (type === 'prev') {

  		if (imageModal.imageIndex !== 0) { //IF not first slide
        let data = masonryData[imageModal.imageIndex - 1];
				
        setImageModal((modal) => ({
          ...modal,
          imageIndex: imageModal.imageIndex - 1,
          modalSrc: urlFor(data.asset).url()
        }));
      }
    }

  	else if (type === 'next') {
      if (imageModal.imageIndex !== masonryData.length) { //IF last slide
        let data = masonryData[imageModal.imageIndex + 1];

  			setImageModal((modal) => ({
          ...modal,
          imageIndex: imageModal.imageIndex + 1,
          modalSrc: urlFor(data.asset).url()
        }));
      }
    }
  };

  return (
    <>
      <Masonry
        className="photo-list"
        elementType={'ul'}
        disableImagesLoaded={false} // default false
        updateOnEachImageLoad={false} // default false and works only if disableImagesLoaded is false
        options={masonryOptions} // default {}
      >
        {childElements}
      </Masonry>

      {imageModal.showModal && (
        <div
          id="modal"
          className="modal"
          style={{
            display: imageModal.showModal ? 'flex' : 'none'
          }}
        >
          {/* Modal Close Btn */}
          <span
            className="modal__close"
            onClick={() =>
              setImageModal((modal) => ({
                ...modal,
                showModal: false,
                disablePage: false
              }))
            }
          >
            &times;
          </span>

          {/* Modal Prev Slide Btn */}
          <button href="#" id="modal__prev" className={imageModal.imageIndex === 0 ? 'hide' : 'show'} onClick={() => onSet('prev')}>
            &#10094;
          </button>

          <div className="image__slider" style={{ display: imageModal.showModal ? 'flex' : 'none' }}>
            <img className="modal__content" id="img01" src={imageModal.modalSrc} alt="" />
          </div>

          {/* Modal Next Slide Btn */}
          <button
            href="#"
            id="modal__next"
            className={imageModal.imageIndex === masonryData.length - '1' ? 'hide' : 'show'}
            onClick={() => onSet('next')}
          >
            &#10095;
          </button>

          <div />
        </div>
      )}
    </>
  );
};

export default MasonryGrid;
